const wordaful = {
  "heading": "You could win a WORDAFUL membership",
  "bodyCopy": "We're celebrating Hispanic Heritage Month by honoring the spirit of affirmations and the connections they bring to communities. Enter for a chance to win WORDAFUL swag, memberships, or even a mentorship with founder Liz Hernandez.",
  "cta": {
    "label": "ENTER NOW",
    "id": "enter-now",
    "href": "https://attthanks.att.com/hispanicheritagesweeps/redemption",
    "color": "primary"
  },
  "disclaimer": ""
}

module.exports = wordaful;
